import {Modal} from "bootstrap";

export const openBootstrapModal = modalId => {
  if (!modalId) return;

  const myModal = new Modal(document.getElementById(`${modalId}`));
  myModal?.show();
};
